import CreatePassword from '@/app/create-password/CreatePassword'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  const { token } = Route.useSearch()

  return <CreatePassword token={token} />
}

export const Route = createFileRoute('/_unauth/create-password')({
  component: RouteComponent,
})


